import Vuex from 'vuex'
import user from './modules/user'
import cart from './modules/cart'
import order from './modules/order'

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  // 组合各个模块
  modules: {
    user,
    cart,
    order
  }
})



// WEBPACK FOOTER //
// ./src/stores/index.js